











































import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import {
  ProxyDelayIntervalType,
  ProxyDelayPropertyType,
} from '../../../logic/Proxy/ProxyDelayTypes'

@Component
export default class SampleDelayLimit extends Vue {
  @Prop() delay!: ProxyDelayIntervalType | ProxyDelayPropertyType

  @Prop() i18n!: i18n

  getDayOfWeek(day: number): string {
    const days = [
      'pi_base_weekday_monday_key',
      'pi_base_weekday_tuesday_key',
      'pi_base_weekday_wednesday_key',
      'pi_base_weekday_thursday_key',
      'pi_base_weekday_friday_key',
      'pi_base_weekday_saturday_key',
      'pi_base_weekday_sunday_key',
    ]

    return this.i18n.t(`${ days[day - 1] }`).toString()
  }
}
